import { Maybe } from "src/generated/graphqlTypes";
import {
  BidPackageDetailActiveRequestFragment,
  BidPackageDetailPage_BidContractRevisionFragment,
} from "src/routes/bids/BidPackageDetailPage.generated";

export function getBidPackageTradesWithEstimate(bp: {
  isInternalEstimate: boolean;
  internalEstimateBidContract?: Maybe<{ id: string }>;
  activeRequests: BidPackageDetailActiveRequestFragment[];
  latestVersion: { latestBidContractRevisions: BidPackageDetailPage_BidContractRevisionFragment[] };
}) {
  if (bp.isInternalEstimate) {
    return [
      {
        id: "hbr",
        tradePartner: { id: "hb", name: "Homebound" },
        bidContract: bp.internalEstimateBidContract,
        bidContractRevision: bp.latestVersion.latestBidContractRevisions.first,
      },
    ];
  }
  return bp.activeRequests.map((request) => ({
    ...request,
    bidContractRevision: bp.latestVersion.latestBidContractRevisions.find(
      (bcr) => bcr.bidContract.tradePartner?.id === request.tradePartner.id,
    ),
  }));
}
